import '../App.css';
import Navigation from '../componets/Navigation';
import Footer from '../componets/Footer';
import { globalVar } from '../globalVar';

function data(i: number)
{
    var dzien = 0;
    var miesiac= 0;
    var miesiacTyp = 0; 
    var rok= 0;
    var miesiacOut= "";
    var dzientyg= "";
    globalVar.map((map,index) => {
        dzien = parseInt(map.dzien);
        miesiac = parseInt(map.miesiac);
        rok = parseInt(map.rok);
        return 0;
    })
    if (i === 1) {dzientyg = "Poniedziałek"}
    if (i === 2) {dzientyg = "Wtorek"}
    if (i === 3) {dzientyg = "Środa"}
    if (i === 4) {dzientyg = "Czwartek"}
    if (i === 5) {dzientyg = "Piątek"}
    if (i === 6) {dzientyg = "Sobota"}
    if (i === 7) {dzientyg = "Niedziela"}
    if (i === 9) {dzientyg = ""}
    if(miesiac === 1 || miesiac === 3 || miesiac === 5 || miesiac === 7 || miesiac === 8 || miesiac === 10 || miesiac === 12)
    {
        miesiacTyp = 0;
    }
    if(miesiac === 4 || miesiac === 6 || miesiac === 9 || miesiac === 11)
    {
        miesiacTyp = 1;
    }
    if(miesiac === 2 && rok%4 !== 0)
    {
        miesiacTyp = 2;
    }
    if(miesiac === 2 && rok%4 === 0)
    {
        miesiacTyp = 3;
    }
    if(miesiacTyp === 0)
    {
        if(dzien + i > 31)
        {
            miesiac = miesiac + 1;
            dzien = (dzien + i) - 31
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>
        }
        else
        {
            dzien = dzien + i
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>

        }
    }
    if(miesiacTyp === 1)
    {
        if(dzien + i > 30)
        {
            miesiac = miesiac + 1;
            dzien = (dzien + i) - 30
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>
        }
        else
        {
            dzien = dzien + i
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>

        }
    }
    if(miesiacTyp === 2)
    {
        if(dzien + i > 28)
        {
            miesiac = miesiac + 1;
            dzien = (dzien + i) - 28
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>
        }
        else
        {
            dzien = dzien + i
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>

        }
    }
    if(miesiacTyp === 3)
    {
        if(dzien + i > 29)
        {
            miesiac = miesiac + 1;
            dzien = (dzien + i) - 30
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>
        }
        else
        {
            dzien = dzien + i
            if(miesiac < 10)
            {
                miesiacOut = "0"+String(miesiac);
            }
            else
            {
                miesiacOut=String(miesiac);
            }
            return <tr><td>{dzientyg} {dzien}.{miesiacOut}</td><td></td></tr>

        }
    }
}


function Intencje() {
  return (
    <>
      <Navigation />
      <div className="article">
            <div className='title'>Intencje Mszalne  na  14.04 - 21.04</div>
            <table>
                {data(1)}
                <tr><td>18:00</td><td>++ Stanisław Zofia Jachyra</td></tr>
                {data(2)}
                <tr><td>7:00</td><td>++ Jan Jaromin, rodzice, Piotr teść</td></tr>
                {data(3)}
                <tr><td>18:00</td><td>+ Władysław Tobiczyk</td></tr>
                
                <tr><td>WIELKI CZWARTEK 17.04</td><td></td></tr>
                <tr><td>18:00</td><td>1. Dziękczynna za dar kapłaństwa</td></tr>
                <tr><td>18:00</td><td>2. + Grzegorz Antecki (od mamy)</td></tr>
                
                <tr><td>WIELKI PIĄTEK 18.04</td><td></td></tr>
                <tr><td><strong>LITURGIA MĘKI PAŃSKIEJ</strong></td></tr>
                
                <tr><td>WIELKA SOBOTA 19.04</td><td></td></tr>
                <tr><td>18:00</td><td>1. ++ Władysław Zofia Klimczyk</td></tr>
                <tr><td>18:00</td><td>2. + Andrzej Krzyścin (od brata Wojciecha z rodz.)</td></tr>
                
                <tr><td>NIEDZIELA ZMARTWYCHWSTANIA 20.04</td><td></td></tr>
                <tr><td>7:00</td><td>1. ++ Julian Rozalia Wandor 1 rocz., 3-ch synów</td></tr>
                <tr><td>7:00</td><td>2. + Jan Krzyścin (od siostrzenicy Marty z rodz.)</td></tr>
                <tr><td>11:00</td><td>1. Za parafian</td></tr>
                <tr><td>11:00</td><td>2. + Małgorzata Frączek (od szwagra Władysława z rodz.)</td></tr>

                <tr><td>PONIEDZIAŁEK WIELKANOCNY 21.04</td><td></td></tr>
                <tr><td>7:00</td><td>1. ++ Stanisław Śliwiński, Emil brat, rodzice, tesciowie</td></tr>
                <tr><td>7:00</td><td>2. + Ludwik Frączek (od wnuka Jakuba z żoną)</td></tr>
                <tr><td>11:00</td><td>1. ++ Jan Stanisława 4 rocz. Antecka, rodzice</td></tr>
                <tr><td>11:00</td><td>2. Dziękczynna za łaskę sakramentu chrztu Lucjana, z prośbą o błog. Boże i opiekę MB dla niego, rodziców, chrzestnych i rodziny</td></tr>
            </table>
            </div>
      <Footer />
    </>
  );
}

export default Intencje;
